import { showSxS } from '../actions/publicActions';
import sxsStore from '../store/Store';
import { mutator } from 'satcheljs';

mutator(showSxS, actionMessage => {
    const { customization } = actionMessage;
    if (customization !== null && customization !== undefined) {
        sxsStore.customization = customization;
    }
});
